import { render } from "./AddOrEditDiscountGroup.html?vue&type=template&id=88781fbe&scoped=true"
import script from "./AddOrEditDiscountGroup.js?vue&type=script&lang=js"
export * from "./AddOrEditDiscountGroup.js?vue&type=script&lang=js"

import "./AddOrEditDiscountGroup.css?vue&type=style&index=0&id=88781fbe&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88781fbe"]])

export default __exports__